// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'
import { Get } from 'config/apiServiceConfig'
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { transformObjtoQuery, transformArrayToUrlPath } from 'helpers'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const getHubDetailList_HD = (id: any, query = ''): any =>
  axios.get(`${baseUrl}/api/logs/product/${id}${query}`)

export const getHubHistory = (payload: any, search: any): any => {
  const { location_id, product_id, pageIndex, status_id } = payload
  const {
    date_range: { createdDateFrom, createdDateTo },
  } = search

  return Get({
    url: '/api/ims/v2/inventories/stock-history',
    params: {
      pageIndex,
      productId: product_id,
      locationId: location_id,
      createdDateFrom,
      createdDateTo,
      ...(status_id
        ? {
            statusId: status_id,
          }
        : {}),
    },
  })
}

export const getInventoryLocation = (payload: any, search: any): any => {
  const { location_id, product_id, pageIndex } = payload
  const {
    date_range: { createdDateFrom, createdDateTo },
  } = search
  const query = transformObjtoQuery({
    pageIndex,
    createdDateFrom,
    createdDateTo,
  })
  const url = transformArrayToUrlPath(['api', 'inventory', 'location', location_id, product_id])
  return axios.get(`${baseUrl}${url}${query}`)
}

export const getInventoryStatus = (): any => {
  const url = transformArrayToUrlPath(['api', 'inventory-status'])

  return axios.get(`${baseUrl}${url}`)
}

export const saveInventoryLocation = (data: any): any =>
  axios.post(`${baseUrl}/api/ims/v2/inventories/detail`, data)

export const updateInventoryLocation = (data: any, id: any): any =>
  axios.put(`${baseUrl}/api/ims/v2/inventories/detail/${id}`, data)

type WimsUpdateInventoryLocationPayloadType = {
  rack_id: number
  active: boolean
  status?: number
  status_note?: number
  stock: number
  expiry_date?: number
  is_delete_expiry_date?: boolean
  inventory_adjustment_reason_id?: number
}

export const wimsUpdateInventoryLocation = (
  id: number,
  data: WimsUpdateInventoryLocationPayloadType,
) =>
  axiosInstanceApiGateway.Put({
    url: `/wims/internal/v1/inventories/detail/${id}`,
    data,
  })

export const getProductDetail_HD = (id: any): any =>
  axios.get(`${baseUrl}/api/inventories/hub/${id}`)
